import AssignmentForm from "../components/AssignmentForm";
import Banner from "../components/Banner";
import Faqs from "../components/Faqs";
import HowItWork from "../components/HowItWork";
import Testimonials from "../components/Testimonials";
import WhyChooseUs from "../components/WhyChooseUs";
import SEO from "../global/SEO";

const Home = () => (
  <>
    <SEO 
      title="Live Assignment Help | Online Assignment Writing Experts - 24/7 Support"
      description="Struggling with academic deadlines? Get expert assignment help online from LiveAssignment.com. 100% plagiarism-free work, on-time delivery & unlimited revisions!"
      keywords="assignment help, online assignment writing, academic help, essay help, dissertation help, coursework help, plagiarism-free assignments, 24/7 assignment support, assignment writing experts, academic writing services"
      h1Heading="Top-Quality Assignment Help Services for Students Worldwide"
      canonicalUrl="https://liveassignment.com"
    />
    <Banner />
    <AssignmentForm ishomepage={true} />
    <WhyChooseUs />
    <HowItWork />
    <Faqs />
    <Testimonials />
  </>
);

export default Home;
